$(function () {
    function activateTab($tabsRoot, $newTab, options) {
        const opts = $.extend({ focusTab: false, focusPanel: false, updateHash: false }, options);
        const $tabs = $tabsRoot.find('[role="tab"]');
        const newPanelId = $newTab.attr('aria-controls');
        const $panels = $tabsRoot.find('[role="tabpanel"]');
        const $newPanel = $('#' + newPanelId);

        $tabs.removeClass('is-current')
            .attr('aria-selected', 'false')
            .attr('tabindex', '-1');

        $panels.attr('hidden', true);

        $newTab.addClass('is-current')
            .attr('aria-selected', 'true')
            .attr('tabindex', '0');

        $newPanel.removeAttr('hidden');

        if (opts.focusPanel) {
            $newPanel.trigger('focus');
        } else if (opts.focusTab) {
            $newTab.trigger('focus');
        }

        if (opts.updateHash) {
            if (history.replaceState) {
                history.replaceState(null, '', '#' + newPanelId);
            } else {
                window.location.hash = newPanelId;
            }
        }
    }

    function initTabs($root) {
        const $tabs = $root.find('[role="tab"]');
        const $panels = $root.find('[role="tabpanel"]');

        // Ensure all panels except the selected tab’s panel are hidden (safety)
        const $selected = $tabs.filter('[aria-selected="true"]').first();
        const selectedPanelId = $selected.attr('aria-controls');

        $panels.each(function () {
            const isSelectedPanel = $(this).attr('id') === selectedPanelId;
            $(this).attr('hidden', !isSelectedPanel);
        });

        // If URL hash matches a panel id, activate it on load
        const hash = (window.location.hash || '').replace('#', '');
        if (hash && $root.find('#' + hash + '[role="tabpanel"]').length) {
            const $hashTab = $tabs.filter('[aria-controls="' + hash + '"]').first();
            if ($hashTab.length) {
                activateTab($root, $hashTab, { focusTab: false, focusPanel: false, updateHash: false });
            }
        }
    }

    // Click activation (anchors behave like tabs)
    $(document).on('click', '[data-tabs] [role="tab"]', function (e) {
        e.preventDefault();
        const $root = $(this).closest('[data-tabs]');
        activateTab($root, $(this), { focusTab: false, focusPanel: false, updateHash: true });
    });

    // Keyboard interaction on tabs
    $(document).on('keydown', '[data-tabs] [role="tab"]', function (e) {
        const $root = $(this).closest('[data-tabs]');
        const $tabs = $root.find('[role="tab"]');
        const idx = $tabs.index(this);

        let nextIdx = null;

        switch (e.key) {
            case 'ArrowLeft':
                nextIdx = (idx - 1 + $tabs.length) % $tabs.length;
                e.preventDefault();
                activateTab($root, $tabs.eq(nextIdx), { focusTab: true, focusPanel: false, updateHash: true });
                break;

            case 'ArrowRight':
                nextIdx = (idx + 1) % $tabs.length;
                e.preventDefault();
                activateTab($root, $tabs.eq(nextIdx), { focusTab: true, focusPanel: false, updateHash: true });
                break;

            case 'Home':
                e.preventDefault();
                activateTab($root, $tabs.eq(0), { focusTab: true, focusPanel: false, updateHash: true });
                break;

            case 'End':
                e.preventDefault();
                activateTab($root, $tabs.eq($tabs.length - 1), { focusTab: true, focusPanel: false, updateHash: true });
                break;

            case 'Enter':
            case ' ':
                e.preventDefault();
                activateTab($root, $(this), { focusTab: false, focusPanel: false, updateHash: true });
                break;
        }
    });

    // Initialize each tabs root
    $('[data-tabs]').each(function () {
        initTabs($(this));
    });
});
